export const PLAYER_VOLUME = 'PLAYER_VOLUME';
export const PLAYER_VIDEO_QUALITY = 'PLAYER_VIDEO_QUALITY';
export const PLAYER_AUDIO = 'PLAYER_AUDIO';

export const setVolume = volume => {
    return {
        type: PLAYER_VOLUME,
        volume,
    };
};

export const setVideoQuality = quality => {
    return {
        type: PLAYER_VIDEO_QUALITY,
        videoQuality: quality,
    };
};

export const setAudio = language => {
    return {
        type: PLAYER_AUDIO,
        audio: language,
    };
};
